<template>
  <div class="browse-vehicles-background-component" id="browse-vehicles-search-hero" role="region">
    <div class="background-row"
      :style="{backgroundImage: bgPhoto}">
    </div>
    <div class="overlay-content">
      <video v-if="images.videoLink.length > 0" autoplay="true" class="hidden-xs" id="homepage-background-video" loop="true" muted="true">
        <source class="ajax-video" :src="images.videoLink" type="video/mp4">
      </video>
      <div class="browse-vehicles">
        <div class="container">
          <div class="browse-step" id="coa-step">
            <h1 class="text-center step-instructions">Welcome to Auto Dealer</h1>
          </div>
          <div class="browse-step" id="search-step">
            <div class="row search-row">
              <div class="col-xs-12">
                <p class="search-instructions">Find your next vehicle here &nbsp;</p>
              </div>
              <div class="col-xs-12">
                <div class="search-bar">
                  <form action="/vehicles" role="search">
                    <div class="input-group">
                      <input aria-label="Search Bar" autocomplete="off" autocorrect="off" class="form-control input-search" data-custom="false" data-placement="bottom" data-search-suggestions="true" data-suggest="true" data-top="Search this site..." name="query" placeholder="Search this site..." spellcheck="false" title="Search this site..." type="text" value="">
                      <span class="input-group-btn">
                        <button aria-label="search text" class="btn btn-default no-border-left" type="submit">
                          <i aria-hidden="true" class="fa fa-search"></i>
                        </button>
                      </span>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="row browse-row vehicle-browse-row">
              <div class="col-xs-12 vehicle-browse-ajax">
                <div class="vehicle-browse-ajax">
                  <form action="/vehicles" class="vehicle-search-form" method="get">
                    <input class="inventory-type set-on-load" name="new" type="hidden" value="true">
                    <div class="form-group">
                      <label class="visuallyhidden" for="dropdown-vehicle-type">Select vehicle type:</label>
                      <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search search-inv-type" id="dropdown-vehicle-type" name="type">
                        <option data="true" value="new">New</option>
                        <option data="false" value="used">Used</option>
                      </select>
                      <i class="material-icons">keyboard_arrow_down</i>
                    </div>
                    <div class="form-group">
                      <label class="visuallyhidden" for="dropdown-vehicle-make">Select vehicle make:</label>
                      <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-make" id="dropdown-vehicle-make" name="make">
                        <option value="make">{{ brandName }}</option>
                      </select>
                      <i class="material-icons">keyboard_arrow_down</i>
                    </div>
                    <div class="form-group">
                      <label class="visuallyhidden" for="dropdown-vehicle-model">Select vehicle model:</label>
                      <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-model" id="dropdown-vehicle-model" name="model">
                        <option value="default">Model</option>
                      </select>
                      <i class="material-icons">keyboard_arrow_down</i>
                    </div>
                    <div class="form-group">
                      <label class="visuallyhidden" for="dropdown-vehicle-year">Select vehicle year:</label>
                      <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-year" id="dropdown-vehicle-year" name="year">
                        <option value="default">Year</option>
                      </select>
                      <i class="material-icons">keyboard_arrow_down</i>
                    </div>
                    <div class="form-group" id="search-submit">
                      <input aria-label="Click here to submit" class="btn btn-block btn-lg search-form-btn vehicle-search-submit" value="Search">
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="browse-step" id="buttons-step">
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-xs-12 New-Vehicles">
                <a href="#" class="track-click btn inventory-type-button-block" data-category="Home Page Actions" data-action="Browse New Vehicles">New Vehicles</a>
              </div>
              <div class="col-lg-3 col-sm-6 col-xs-12 Used-Vehicles">
                <a href="#" class="track-click btn inventory-type-button-block" data-category="Home Page Actions" data-action="Browse Used Vehicles">Used Vehicles</a>
              </div>
              <div class="col-lg-3 col-sm-6 col-xs-12 Schedule-Service">
                <a href="#" class="track-click btn inventory-type-button-block" data-category="Home Page Actions" data-action="Service">Schedule Service</a>
              </div>
              <div class="col-lg-3 col-sm-6 col-xs-12 Specials">
                <a href="#" class="track-click btn inventory-type-button-block" data-category="Home Page Actions" data-action="Specials">Specials</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    },
    bgPhoto () {
      if (this.brand !== 'honda') {
        return 'url(' + this.images.lifestyleImages.defaultImage + ')';
      } else {
        return 'url(' + this.images.lifestyleImages.suvImage + ')';
      }
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.visuallyhidden {
  display: none;
}
#browse-vehicles-search-hero {
  height: auto;
  position: relative;
  overflow: hidden;
  font-family: var(--body-text);
}
#browse-vehicles-search-hero .background-row {
  position: absolute;
  z-index: -1;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  overflow: hidden;
  background-size: cover;
  background-color: #222;
  background-repeat: no-repeat;
  background-position: 50% 50%;
}
#browse-vehicles-search-hero .browse-row {
  margin: 30px 0 30px;
}
#browse-vehicles-search-hero .search-instructions {
  font-size: 18px;
  color: #fff;
  float: left;
  padding-left: 15px;
}
#browse-vehicles-search-hero .step-instructions {
  color: #fff;
  font-family: var(--heading-text);
}
#browse-vehicles-search-hero .overlay-content {
  background: rgba(0,0,0,.2);
  min-height: 600px;
  padding-top: 5%;
  padding-bottom: 5%;
}
#browse-vehicles-search-hero .search-row input {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}
#browse-vehicles-search-hero .search-row .btn {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
#browse-vehicles-search-hero .browse-row .vehicle-search-submit {
  border-radius: 4px;
}
video#homepage-background-video {
  position: absolute;
  top: -18%;
  left: 0;
  min-width: 100%;
  min-height: 118%;
  width: auto;
  height: auto;
  z-index: -1;
  background-size: cover;
  }
#browse-vehicles-search-hero .vehicle-browse-row {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-size: cover;
}
#browse-vehicles-search-hero .vehicle-browse-ajax {
  width: 100%;
  max-width: 1024px;
  margin: 0 auto 25px;
  z-index: 2;
}
#browse-vehicles-search-hero .vehicle-browse-ajax .form-group {
  flex-grow: 1;
  position: relative;
  border-radius: 6px;
}
#browse-vehicles-search-hero .vehicle-browse-ajax .form-group:not(#search-submit) {
  background-color: #fff;
}
#browse-vehicles-search-hero .vehicle-browse-ajax .form-group i {
  position: absolute;
  line-height: 48px;
  right: 12px;
  top: 0;
}
#browse-vehicles-search-hero .vehicle-browse-ajax .form-control {
  display: block;
  width: 100%;
  height: 100%;
  line-height: 32px;
  border-radius: 6px;
  position: relative;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  z-index: 1;
  background-color: transparent;
}
#browse-vehicles-search-hero .vehicle-browse-ajax .search-form-btn.vehicle-search-submit {
  background-color: var(--primary-color);
  color: #fff;
  border: none;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 2px;
  line-height: 32px;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
#browse-vehicles-search-hero .vehicle-browse-ajax .search-form-btn.vehicle-search-submit:hover, #browse-vehicles-search-hero #buttons-step .btn:hover {
  filter: brightness(1.3);
  color: #fff;
}
#browse-vehicles-search-hero #buttons-step .btn {
  display: block;
  padding: 12px 15px;
  background-color: var(--primary-color);
  color: #fff;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 0px auto 15px;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
@media (max-width: 991px) {
  #browse-vehicles-search-hero .browse-row .vehicle-search-submit {
    font-size: 1.5em;
    padding: 11px 10px;
  }
}
#browse-vehicles-search-hero .browse-vehicles {
  background-color: transparent;
}
@media (min-width: 768px) {
  #browse-vehicles-search-hero .browse-row {
    padding: 0 15px;
  }
  #browse-vehicles-search-hero .search-row {
    padding: 0 30px;
  }
  #browse-vehicles-search-hero .vehicle-search-form {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
  }
  #browse-vehicles-search-hero .vehicle-browse-ajax .form-group {
    flex-basis: 20%;
  }
  #browse-vehicles-search-hero .vehicle-browse-ajax .form-group:not(:last-child) {
    margin-right: 12px;
  }
}
</style>